module.exports = __webpack_public_path__ + "img/intensive-expert.f8204095.png";